export const KINDS = ["overlay", "video", "audio"]

export const KIND_LABELS = {video: "Video", overlay: "Overlay", audio: "Audio"}

// The top row is drawn in front
export function default_tracks () {
	return [
		{id: "t-overlay-1", kind: "overlay", name: "Overlay 1", hidden: false},
		{id: "t-video-1", kind: "video", name: "Video 1", hidden: false},
		{id: "t-audio-1", kind: "audio", name: "Audio 1", hidden: false}
	];
}

export function default_active () {
	return {video: "t-video-1", overlay: "t-overlay-1", audio: "t-audio-1"};
}

export function default_counter () {
	return {video: 1, overlay: 1, audio: 1};
}

// Highest number used in the track names of each kind, so new tracks get unused names
export function count_tracks (tracks) {
	const counter = {};
	_.each(KINDS, (kind) => {
		const of_kind = _.filter(tracks, {kind: kind});
		const numbers = _.map(of_kind, (t) => parseInt((String(t.name).match(/(\d+)\s*$/) || [])[1], 10) || 0);
		counter[kind] = Math.max(of_kind.length, ...numbers);
	});
	return counter;
}

// Tracks are listed by id; items refer to them with the id
export function resolve_tracks (edl, groups) {
	if (!Array.isArray(edl.tracks)) throw new Error("Invalid timeline file");
	const tracks = [];
	_.each(edl.tracks, (t) => {
		if (t && _.includes(KINDS, t.kind) && t.id != null && !_.some(tracks, {id: String(t.id)})) {
			tracks.push({id: String(t.id), kind: t.kind, name: String(t.name || ""), hidden: t.hidden === true, muted: t.muted === true});
		}
	});
	_.each(KINDS, (kind) => {
		if (!_.some(tracks, {kind: kind})) tracks.push({id: "t-" + kind + "-1", kind: kind, name: "", hidden: false, muted: false});
	});
	const seen = {};
	_.each(tracks, (t) => {
		seen[t.kind] = (seen[t.kind] || 0) + 1;
		if (!t.name) t.name = KIND_LABELS[t.kind] + " " + seen[t.kind];
	});
	_.each(KINDS, (kind) => {
		const of_kind = _.filter(tracks, {kind: kind});
		_.each(groups[kind], (item) => {
			item.track = (_.find(of_kind, {id: String(item.track)}) || of_kind[0]).id;
		});
	});
	return tracks;
}
